import { Map, Record } from 'immutable';
import { fetchNewValidation, fetchEditValidationActions, fetchExistingValidationActions, actionTypes } from './validate-intake-form.actions';
import * as api from '../../api';

export const ValidateIntakeState = Record({
  newFormValidation: api.ApiCallState({}),
  editFormValidation: Map({}),
  formValidation: Map({}),
});

export const validateIntakeReducer = (initialState = new ValidateIntakeState(), action) => {
  var state = initialState;

  state = state.set('newFormValidation',
    api.apiCallReducer(state.get('newFormValidation'), action, fetchNewValidation, [actionTypes.INVALIDATE_NEW_VALIDATION]));

  if(action.formId) {
    state = state.setIn(['editFormValidation', action.formId],
      api.apiCallReducer(state.getIn(['editFormValidation', action.formId]), action, fetchEditValidationActions, [actionTypes.INVALIDATE_EDIT_VALIDATION]));

    state = state.setIn(['formValidation', action.formId],
      api.apiCallReducer(state.getIn(['formValidation', action.formId]), action, fetchExistingValidationActions));
  }


  switch(action.type) {
    default: return state;
  }
}
